import React from 'react';
import { GOLD } from '../../constants/theme';

const Divider: React.FC = () => (
  <div style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'center', margin:'10px 0' }}>
    <div style={{ width:36, height:1, background:`linear-gradient(to right,transparent,${GOLD})` }}/>
    <svg width="26" height="10" viewBox="0 0 26 10">
      <path d="M0 5 L5 1 L9 5 L13 2 L17 5 L21 1 L26 5 L21 9 L17 5 L13 8 L9 5 L5 9 Z"
        fill="none" stroke={GOLD} strokeWidth="1"/>
    </svg>
    <div style={{ width:36, height:1, background:`linear-gradient(to left,transparent,${GOLD})` }}/>
  </div>
);

export default Divider;